goog.provide("shadow.js.shim.module$$mui$x_tree_view$RichTreeView");
goog.provide("module$shadow_js_shim_module$$mui$x_tree_view$RichTreeView");
shadow.js.shim.module$$mui$x_tree_view$RichTreeView = shadow.js.nativeProvides["@mui/x-tree-view/RichTreeView"] = shadow$bridge("@mui/x-tree-view/RichTreeView");
module$shadow_js_shim_module$$mui$x_tree_view$RichTreeView.default = shadow.js.shim.module$$mui$x_tree_view$RichTreeView;
